/**
 * Analytics identifiers for PLANS DE SOUDURE™.
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '2136422443914724'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
